module.exports = __webpack_public_path__ + "static/deck_of_many_things-ac4707683a6432486c6e610a65511113.png";